/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import { MdSignalWifiConnectedNoInternet0 } from 'react-icons/md'

import AssetTableCell from './AssetTableCell'
import { convertTemperature, formatDate12, getTempMpColMeta, joinStrings, timeSinceFormatted } from './utils'

import { TemperatureUnit } from '../types'

type TempMpColProps = {
  value: number
  tagSampleTime: Date
  tagOnline: boolean
  gatewayOn: boolean
  temperatureUnit?: TemperatureUnit
}

const TempMpCol: React.FC<TempMpColProps> = ({
  value,
  tagSampleTime,
  tagOnline,
  gatewayOn,
  temperatureUnit = 'Metric',
}) => {
  const { isValueBlank, displayBlank, displayMissing } = getTempMpColMeta(gatewayOn, tagOnline, value)
  const lastValue = isValueBlank ? '<No reading>' : convertTemperature(value, temperatureUnit)

  const lastReportedString = tagSampleTime
    ? `Last value reported at ${formatDate12(tagSampleTime)} ${timeSinceFormatted(tagSampleTime)}`
    : ''
  const lastValueString = `Last value: ${lastValue}`

  let tooltip = lastReportedString
  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (displayBlank) {
    tooltip = joinStrings(lastReportedString, lastValueString)
  } else if (displayMissing) {
    tooltip = joinStrings('No data available', lastReportedString, lastValueString)
    displayValue = <MdSignalWifiConnectedNoInternet0 className="w-4 h-4 text-gray-500" />
  } else {
    displayValue = convertTemperature(value, temperatureUnit)
  }

  return <AssetTableCell tooltip={tooltip}>{displayValue}</AssetTableCell>
}

export default TempMpCol
